import { useMeQuery } from "@saffron/controllers";
import React from "react";
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps
} from "react-router-dom";

type Props = RouteProps;

export const AuthRoute: React.FC<Props> = ({ component, ...rest }) => {
  const { data, loading } = useMeQuery();
  return (
    <Route
      {...rest}
      render={(rProps: RouteComponentProps<any>) => {
        if (!data || loading) {
          return null;
        }

        if (!data.me || !data.me.user) {
          return (
            <Redirect
              to={{
                pathname: "/login/na",
                state: { next: rProps.location }
              }}
            />
          );
        }

        const RouteC = component as any;

        return <RouteC {...rProps} />;
      }}
    />
  );
};
